import Review from "./Review";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Review />
    </div>
  );
}

export default App;
